import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDebitorRcvWithDetailsApi,
  getDebitorReciptCodeApi,
  getDueEmisApi,
  getDueSalesVoucherApi,
  getSundryDebitorBalanceApi,
  saveDebitorReciptApi,
  deleteDebitorReciptApi,
  getDuePurchaseReturns,
} from "../../apiservice/accounts";
import { getAccountByTypeApi } from "../../apiservice/setting";


// 🔹 Fetch all receipts
export const fetchReceipts = createAsyncThunk(
  "customerReceipts/fetchReceipts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getDebitorRcvWithDetailsApi({ oneDate: null });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Fetch new receipt code
export const fetchReceiptCode = createAsyncThunk(
  "customerReceipts/fetchReceiptCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getDebitorReciptCodeApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Fetch due vouchers for a customer
export const fetchDueVouchers = createAsyncThunk(
  "customerReceipts/fetchDueVouchers",
  async (customerId, { getState, rejectWithValue }) => {
  try {
      const res = await getDueSalesVoucherApi({ customerId });
      return { customerId, vouchers: res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const fetchDuePurchaseReturns = createAsyncThunk(
  "customerReceipts/fetchDuePurchaseReturns",
  async (supplierId, { rejectWithValue }) => {
    try {
      const res = await getDuePurchaseReturns( { supplierId });
      return { supplierId, returns: res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
// 🔹 Fetch due EMIs for a customer
export const fetchDueEmis = createAsyncThunk(
  "customerReceipts/fetchDueEmis",
  async (customerId, { rejectWithValue }) => {
    try {
      const res = await getDueEmisApi({ customerId });
      return { customerId, emis: res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Fetch customer previous balance
export const fetchCustomerBalance = createAsyncThunk(
  "customerReceipts/fetchCustomerBalance",
  async (customerId, { rejectWithValue }) => {
    try {
      const res = await getSundryDebitorBalanceApi({ customerId });
      return { customerId, balance: {
          total_balance: res.data.total_balance,
          opening_balance: res.data.opening_balance, // ✅ IMPORTANT
        }, };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Save (create/update) receipt
export const saveReceipt = createAsyncThunk(
  "customerReceipts/saveReceipt",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveDebitorReciptApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Delete receipt
export const deleteReceipt = createAsyncThunk(
  "customerReceipts/deleteReceipt",
  async (rcv_id, { rejectWithValue }) => {
    try {
      const res = await deleteDebitorReciptApi({ rcv_id });
      return { id: rcv_id, msg: res.data.msg };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const fetchDirectExpenseAccounts = createAsyncThunk(
  "customerReceipts/fetchAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "direct_expense" });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);